// "Nova versão disponível — Atualizar" (painel e aluno): aparece quando um deploy novo assumiu o service worker
// com a página aberta (plataforma/web/pwa.ts). Não interrompe: a pessoa termina o que está fazendo e toca.
import { useState } from "react";
import { aplicarAtualizacao, useAtualizacaoDisponivel } from "@plataforma/pwa";
import { Icones } from "./icones";

export function AvisoAtualizacao() {
  const disponivel = useAtualizacaoDisponivel();
  const [atualizando, setAtualizando] = useState(false);
  if (!disponivel) return null;
  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-[calc(64px+env(safe-area-inset-bottom)+76px)] z-60 flex justify-center px-margem lg:bottom-6 lg:left-6 lg:right-auto lg:justify-start">
      <div
        role="status"
        data-aviso-atualizacao=""
        className="pointer-events-auto flex min-h-12 w-full max-w-app items-center gap-3 rounded-controle bg-tinta px-4 py-2 text-apoio text-sobre-tinta shadow-toast animate-toast-entra lg:w-96"
      >
        <Icones.info size={20} aria-hidden className="shrink-0" />
        <span className="flex-1">Nova versão disponível</span>
        <button
          type="button"
          disabled={atualizando}
          className="h-toque shrink-0 px-2 font-semibold underline underline-offset-4 foco-sobre-tinta"
          onClick={() => {
            setAtualizando(true);
            void aplicarAtualizacao();
          }}
        >
          {atualizando ? "Atualizando…" : "Atualizar"}
        </button>
      </div>
    </div>
  );
}
